module.exports = __webpack_public_path__ + "static/web_dev-1cdd2d80527942f06364bb190c695d86.jpg";